/* eslint-disable func-names,arrow-body-style  */

import _ from 'lodash';
import saveAs from 'file-saver';
import { call, put, takeLatest, select, cancel, takeEvery } from 'redux-saga/effects';

import {
  customVocabularyFetchAll,
  customVocabularyAddRecord,
  customVocabularyRemoveRecords,
  customVocabularyFetchRecord,
} from '../models/CustomVocabulary';
import PredefVocabulary from '../models/PredefVocabularyRecord';

import {
  VOCABULARY_LIST_FETCH_TERMS,
  VOCABULARY_LIST_SET_CURRENT_TERM_NAME,
  VOCABULARY_LIST_SET_CURRENT_TERM,
  VOCABULARY_LIST_SET_CURRENT_TERM_WORDS,
  VOCABULARY_LIST_SET_TERM_IDS,
  VOCABULARY_LIST_SET_LIST_STATE_LOADING,
  VOCABULARY_LIST_SET_LIST_EDIT_STATE,
  VOCABULARY_LIST_SET_LIST_STATE_LOADED,
  VOCABULARY_LIST_SET_LIST_STATE_LOAD_ERROR,
  VOCABULARY_LIST_SET_EDITING_STATE_LOADING,
  VOCABULARY_LIST_SET_EDITING_STATE_LOADED,
  VOCABULARY_LIST_EDITING_SET_EDIT_WORDS,
  VOCABULARY_LIST_EDITING_SET_SEARCH_TERM,
  VOCABULARY_LIST_DELETE_CHECKED_LISTS,
  VOCABULARY_LIST_LIST_STATE_LOADING,
  VOCABULARY_LIST_LIST_STATE_NOT_LOADED,
  VOCABULARY_LIST_SET_EDITING_TERM_NAME,
  VOCABULARY_LIST_START_ADDING_VOCABULARY,
  VOCABULARY_LIST_ADDING_VOCABULARY_RESET,
  VOCABULARY_LIST_STOP_ADDING_VOCABULARY,
  VOCABULARY_LIST_DOWNLOAD_VOCAB_CSV,
  VOCABULARY_LIST_ADD_NEW_VOCABULARY, VOCABULARY_LIST_EDITING_SET_EDIT_WORDS_CHECKLIST,
} from './terminusConstants';

import {
  MODEL_CUSTOM_VOCABULARY_SET_RECORDS,
  MODEL_CUSTOM_VOCABULARY_IDENTITY,
  MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD,
  MODEL_CUSTOM_VOCABULARY_ADD_RECORDS,
  MODEL_CUSTOM_VOCABULARY_ADD_RECORD,
  MODEL_CUSTOM_VOCABULARY_REMOVE_RECORDS,
} from '../models/CustomVocabulary/customVocabularyConstants';
import { providers } from './terminusReducers';


export default (bottle) => {
  bottle.factory('fetchTerms', () => {
    return function* fetchTerms() {
      yield put({ type: VOCABULARY_LIST_SET_LIST_STATE_LOADING });
      try {
        const [token] = yield select((state) => {
          return [
            _.get(state, 'users.ephemeralKey.bearerToken'),
          ];
        });
        if (!token) {
          yield put({ type: VOCABULARY_LIST_SET_LIST_STATE_LOAD_ERROR });
          return;
        }
        const payload = yield call(customVocabularyFetchAll, token);
        yield put({ type: MODEL_CUSTOM_VOCABULARY_SET_RECORDS, payload });
        yield put({
          type: VOCABULARY_LIST_SET_TERM_IDS,
          payload: _.map(payload, MODEL_CUSTOM_VOCABULARY_IDENTITY),
        });
        yield put({ type: VOCABULARY_LIST_SET_LIST_STATE_LOADED });
      } catch (err) {
        yield put({ type: VOCABULARY_LIST_SET_LIST_STATE_LOAD_ERROR });
      }
    };
  });

  bottle.factory('terminusHandlerDownloadGroupCSV', () => {
    return function* spottingGroupHandlerDownloadGroupCSV(input) {
      const name = _.get(input, 'payload.vocabularyName');
      const [token] = yield select((state) => {
        return [
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });
      if (!token) return;
      try {
        const data = yield call(customVocabularyFetchRecord, name, token);
        const file = new Blob([new PredefVocabulary(data).toCSV()], { type: 'text/csv;charset=utf-8' });
        saveAs(file, `${name}.csv`);
      } catch (err) {
        console.log('error: ', err);
      }
    };
  });

  bottle.factory('terminusHandlerAddVocabulary', () => {
    return function* addVocabulary({ payload: newVocabulary }) {
      const [token] = yield select((state) => {
        return [
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (token) {
        yield call(customVocabularyAddRecord, newVocabulary, token);
        yield put({ type: VOCABULARY_LIST_FETCH_TERMS });
      }
      // @TOD: state;
      yield put({ type: VOCABULARY_LIST_ADDING_VOCABULARY_RESET });
      yield put({ type: VOCABULARY_LIST_STOP_ADDING_VOCABULARY });
    };
  });

  bottle.factory('deleteVocabularies', () => {
    return function* deleteVocabularies() {
      const [listChecklist, token] = yield select((state) => {
        return [
          _.get(state, 'terminus.listChecklist'),
          _.get(state, 'users.ephemeralKey.bearerToken'),
        ];
      });

      if (token && listChecklist && Array.isArray(listChecklist)) {
        yield call(customVocabularyRemoveRecords, listChecklist, token);
        yield put(providers.setListStateChecks([]));
        yield put({ type: VOCABULARY_LIST_FETCH_TERMS });
      }
    };
  });

  bottle.factory('loadCurrentName', () => {
    return function* loadCurrentName() {
      const [fetchState, termsByID, vocabularyName] = yield select((state) => {
        return [
          _.get(state, 'terminus.listState'),
          _.get(state, 'modelCustomVocabulary.modelCustomVocabularyById'),
          _.get(state, 'terminus.vocabularyName'),
        ];
      });

      if (fetchState === VOCABULARY_LIST_LIST_STATE_LOADING) {
        return;
      }

      if (!vocabularyName) {
        yield put({ type: VOCABULARY_LIST_SET_CURRENT_TERM, payload: null });
      } else if (fetchState === VOCABULARY_LIST_LIST_STATE_NOT_LOADED) {
        yield put({ type: VOCABULARY_LIST_SET_EDITING_STATE_LOADING });
        yield put({ type: VOCABULARY_LIST_FETCH_TERMS });
      } else {
        const currentTerm = termsByID[vocabularyName];

        yield put({ type: VOCABULARY_LIST_SET_CURRENT_TERM, payload: currentTerm || null });
        yield put({ type: VOCABULARY_LIST_SET_EDITING_STATE_LOADED });
      }
    };
  });

  bottle.factory('terminusHandlerInitEditing', () => {
    return function* () {
      const [isEditing, currentName] = yield select((state) => {
        return [
          _.get(state, 'terminus.isEditingTerms'),
          _.get(state, 'terminus.vocabularyName'),
        ];
      });

      if (isEditing) {
        yield put({ type: VOCABULARY_LIST_SET_EDITING_TERM_NAME, payload: currentName });
      }
    };
  });

  bottle.factory('terminusHandlerInitAddVocabulary', () => {
    return function* () {
      yield put({ type: VOCABULARY_LIST_ADDING_VOCABULARY_RESET });
    };
  });

  bottle.factory('resetListChecks', () => {
    return function* () {
      yield put({ type: VOCABULARY_LIST_EDITING_SET_EDIT_WORDS_CHECKLIST, payload: [] });
    };
  });

  bottle.factory('terminusEditingStartSaga', ({ terminusHandlerInitEditing }) => {
    return function* terminusEditingStartSaga() {
      yield takeLatest([VOCABULARY_LIST_EDITING_SET_EDIT_WORDS], terminusHandlerInitEditing);
    };
  });

  bottle.factory('terminusAddVocabularySaga', ({ terminusHandlerAddVocabulary }) => {
    return function* terminusAddVocabularySaga() {
      yield takeEvery(VOCABULARY_LIST_ADD_NEW_VOCABULARY, terminusHandlerAddVocabulary);
    };
  });

  bottle.factory('terminusDeleteVocabularySaga', ({ deleteVocabularies }) => {
    return function* terminusDeleteVocabularySaga() {
      yield takeEvery(VOCABULARY_LIST_DELETE_CHECKED_LISTS, deleteVocabularies);
    };
  });

  bottle.factory('terminusFetchSaga', ({ fetchTerms }) => {
    return function* terminusFetchSaga() {
      yield takeLatest(VOCABULARY_LIST_FETCH_TERMS, fetchTerms);
    };
  });

  bottle.factory('terminusEditStateResetSaga', ({ resetListChecks }) => {
    return function* terminusEditStateResetSaga() {
      yield takeLatest(VOCABULARY_LIST_SET_LIST_EDIT_STATE, resetListChecks);
    };
  });

  bottle.factory('terminusLoadCurrentNameSaga', ({ loadCurrentName }) => {
    return function* terminusEditingStartSaga() {
      yield takeEvery(
        [
          MODEL_CUSTOM_VOCABULARY_SET_RECORDS,
          MODEL_CUSTOM_VOCABULARY_REMOVE_RECORD,
          MODEL_CUSTOM_VOCABULARY_ADD_RECORDS,
          MODEL_CUSTOM_VOCABULARY_ADD_RECORD,
          MODEL_CUSTOM_VOCABULARY_REMOVE_RECORDS,
          VOCABULARY_LIST_SET_LIST_STATE_LOADED,
          VOCABULARY_LIST_SET_CURRENT_TERM_NAME,
        ],
        loadCurrentName,
      );
    };
  });

  bottle.factory('terminusStartAddingVocabularySaga', ({ terminusHandlerInitAddVocabulary }) => {
    return function* terminusStartAddingVocabularySaga() {
      yield takeEvery(
        VOCABULARY_LIST_START_ADDING_VOCABULARY,
        terminusHandlerInitAddVocabulary,
      );
    };
  });

  bottle.factory('terminusDownloadSaga', ({ terminusHandlerDownloadGroupCSV }) => {
    return function* terminusDownloadSaga() {
      yield takeEvery(
        VOCABULARY_LIST_DOWNLOAD_VOCAB_CSV,
        terminusHandlerDownloadGroupCSV,
      );
    };
  });
};
